import Box from '@mui/material/Box'
import Link from 'next/link'
import { MenuClient, Search } from '@/components/Inputs'
import { resolveHref } from '@/utilites/resolveHref'

interface MenuLink {
    label: string
    url: string
    desktop?: boolean
    mobile?: boolean
}

interface MenuProps {
    menuLinks: MenuLink[]
    tel?: string
    button?: { link?: string; text?: string }
    color?: string
}

const Menu = ({ menuLinks, tel, button, color }: MenuProps) => {
    return (
        <>
            {/* Desktop Menu */}
            <Box
                component={'nav'}
                sx={{ display: { xs: 'none', md: 'flex' } }}
                aria-label='header-menu-desktop'
            >
                <Box
                    component={'ul'}
                    sx={{
                        display: 'flex',
                        listStyle: 'none',
                        alignItems: 'center',
                        flexDirection: 'row',
                        padding: 0,
                        margin: 0,
                        gap: 2,
                    }}
                >
                    {menuLinks
                        .filter((link) => link.desktop)
                        .map((link) => (
                            <li key={link.label}>
                                <Link
                                    href={resolveHref(link.url)}
                                    style={{
                                        textDecoration: 'none',
                                        fontSize: '1.2rem',
                                        fontWeight: 'bold',
                                        textTransform: 'uppercase',
                                        fontFamily: 'MonaSansCondensed, sans-serif',
                                        color: color || 'black',
                                    }}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}

                    <li key='more'>
                        <MenuClient
                            menuLinks={menuLinks.filter((link) => link.mobile)}
                            tel={tel}
                            button={button}
                            color={color}
                            display={{ xs: 'none', md: 'flex' }}
                        />
                    </li>

                    <li key='search'>
                        <Search />
                    </li>
                </Box>
            </Box>

            {/* Mobile Menu Button */}
            <MenuClient
                menuLinks={menuLinks.filter((link) => link.mobile)}
                tel={tel}
                button={button}
                color={color}
                display={{ xs: 'flex', md: 'none' }}
            />
        </>
    )
}

export default Menu


